import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, spacing, border }) => ({
  tag: {
    paddingVertical: spacing(0.5),
    paddingHorizontal: spacing(1.5),
    borderRadius: border.radius.sm,
    backgroundColor: colors.backgroundSurface,
    borderWidth: border.widths.sm,
    borderColor: colors.borderDefault,
  },
  tagText: {
    color: colors.foregroundDefault,
  },
}));

export default stylesheet;
